<template>
  <div class="claim-summary-shell sba-slide-in">
    <div class="claim-summary-card">
      <table class="highlight responsive-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Name<br /><small>(Enrollee ID)</small></th>
            <th>Diagnosis</th>
            <th>Sent Amount</th>
            <th>Encounter</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="claim-summary-row clickable"
            v-for="(encounter, index) in encounters"
            :key="encounter.id"
            @click.prevent="handleStart(encounter)"
          >
            <td>{{ index + 1 }}</td>
            <td>
              {{ encounter.name }}<br />
              ({{ encounter.enrollee_number }})
            </td>
            <td>{{ encounter.diagnosis }}</td>
            <td>
              <b>&#8358;{{ totalSent(encounter) }}</b>
            </td>
            <td>
              {{
                new Date(encounter.encounter_date).toLocaleString(
                  undefined,
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )
              }}
            </td>
            <td>
              <i class="material-icons pointable" :class="{
                'yellow-text text-darken-2': encounter.status == 'p',
              }" :title="`${encounter.status == 'p' ? 'pending' : 'completed'}`" v-if="!isManual">{{
                  encounter.status == "p" ? "watch_later" : "check_circle"
                }}
              </i>
              <i class="material-icons pointable" :class="{
                'grey-text text-darken-2': encounter.status == 'p', 'red-text text-lighten-4': encounter.status == 'o',
              }" :title="`${encounter.status == 'p' ? 'saved' : 'pending'}`" v-else>{{
                  encounter.status == "p" ? "save" : "watch_later"
                }}
              </i>
            </td>
          </tr>

          <tr class="claim-summary-total" v-if="encounters.length">
            <td colspan="2"></td>
            <td>Total Sent:</td>
            <td class="orange-text"><b>&#8358;{{ grandTotalSent(encounters) }}</b></td>
            <td colspan="2"></td>
          </tr>

          <tr v-else>
            <td colspan="6" class="center claim-summary-empty">No Claims Added Yet!</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="progress" v-if="isSubmitting">
      <div class="indeterminate"></div>
    </div>
  </div>
</template>

<script>
import { totalSentInputFx,
  grossTotalSentInputFx, } from "@/composables/calFunction/cal";

export default {
  name: "SummaryClaimComponent",
  props: ["encounters", "isSubmitting", "isManual"],
  emits: ["reload"],
  setup(props, context) {

    // total calculations
    const totalSent = (encounter) => {
      return totalSentInputFx(encounter);
    }

     // total calculations
     const grandTotalSent = (encounter) => {
      return grossTotalSentInputFx(encounter);
    }

    // switch page
    const handleStart = (encounter) => {
      // reload
      context.emit("reload", {
        encounter: encounter,
      });
    };

    return {
      handleStart,
      grandTotalSent,
      totalSent,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -16px;
}

.claim-summary-shell {
  padding: 0;
}

.claim-summary-card,
.claim-summary-row {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.claim-summary-card {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  overflow: hidden;
}

.claim-summary-card table {
  margin: 0;
}

.claim-summary-card thead {
  background: #f8fafb;
  color: #546e7a;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.claim-summary-card th {
  border-bottom: 1px solid #d7e1e5;
  font-weight: 800;
  padding: 14px 16px;
}

.claim-summary-card td {
  border-bottom: 1px solid #e1e8eb;
  padding: 15px 16px;
  vertical-align: middle;
}

.claim-summary-row {
  transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

.claim-summary-row:hover {
  background: #f8fafb;
  box-shadow: inset 3px 0 0 #80cbc4;
}

.claim-summary-total {
  background: #fffaf0;
}

.claim-summary-total td {
  border-bottom: 0;
  font-weight: 800;
}

.claim-summary-empty {
  color: #607d8b;
  font-weight: 700;
  padding: 28px 16px !important;
}

.clickable {
  cursor: pointer;
}

.pointable {
  cursor: default;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.pointable:hover {
  opacity: 0.8;
}

@media (prefers-reduced-motion: reduce) {
  .claim-summary-card,
  .claim-summary-row {
    animation: none;
  }
}
</style>
